import {
  FETCH_CLINICUSER_REQUEST,
  FETCH_CLINICUSER_FAILURE,
  FETCH_CLINICUSER_SUCCESS,
} from "./ActionTypes";

import axios from "../axios";
import axiosVeteriner from "../../../axios/axiosVeteriner";
import { history } from "../../../history";

export const fetchClinicUserRequest = () => {
  return {
    type: FETCH_CLINICUSER_REQUEST,
  };
};
export const fetchClinicUserSuccess = (clinic) => {
  return {
    type: FETCH_CLINICUSER_SUCCESS,
    payload: clinic,
  };
};
export const fetchClinicUserError = (error) => {
  return {
    type: FETCH_CLINICUSER_FAILURE,
    payload: error.message,
  };
};

export const fetchClinicUser = (token) => {
  return (dispatch) => {
    dispatch(fetchClinicUserRequest());
    let config = {
      method: "GET",
      
    };
    axiosVeteriner
      .get("Veterinary/GetLoginVeterinarianUserInfo", config)
      .then((response) => {
        const clinic = response.data.Result;

        dispatch(fetchClinicUserSuccess(clinic));
      })
      .catch((error) => {
        history.push("/logout")
        const errorMsg = error.message;

        // dispatch(fetchClinicUserError(errorMsg));
      });
  };
};
